import { useEffect } from 'react';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';

import showErrorAlert from 'services/errorHandler';
import { ACT_CODE, CLOSE_CODE, SUCCESS_CODE } from 'consts';
import { SimulatorPageType } from 'components/containers/Simulators/CompleteBankSimulator';

interface IProps {
  paymentToken: string;
  simulateResponse: Record<string, any>;
  type?: SimulatorPageType;
  completeUrlParam?: string;
  errorUrlParam?: string;
}

export const useRedirectSimulation = ({
  paymentToken,
  simulateResponse,
  type,
  completeUrlParam = '',
  errorUrlParam = ''
}: IProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (paymentToken) return;

    showErrorAlert({ error: t('3ds_simulator.missing_token_error'), custom: true });
  }, []);

  useEffect(() => {
    if (isEmpty(simulateResponse)) return;

    const {
      status,
      complete_payment_url: completePaymentUrl,
      error_payment_url: errorPaymentUrl,
      next_action: nextAction,
      captured
    } = simulateResponse;
    if (!status || !nextAction) return;

    let paymentMethodUrl, paymentUrl;
    if (type === SimulatorPageType.BankRedirect) {
      const isAddPaymentMethodSuccess = status.toUpperCase() === SUCCESS_CODE;
      paymentMethodUrl = isAddPaymentMethodSuccess ? completeUrlParam : errorUrlParam;
    } else {
      const isPaymentSuccess =
        status === CLOSE_CODE || (captured === false && status === ACT_CODE);
      paymentUrl = isPaymentSuccess ? completePaymentUrl : errorPaymentUrl;
    }

    const redirectUrl = paymentMethodUrl || paymentUrl;

    setTimeout(() => {
      window.location.href = redirectUrl;
    }, 1000);
  }, [simulateResponse]);
};
